import { useEffect, useState } from 'react';

import { consultationApi } from '@entities/consultations';
import { useConsultations } from '@entities/consultations';
import { isAxiosError } from 'axios';

import { xhr } from '@shared/config';
import { usePopup } from '@shared/hooks';
import type { Consultation } from '@shared/types/consultations';

export const useConsultationLoader = (id: number, onError?: () => void) => {
	const { setConsultation } = useConsultations();
	const { popup } = usePopup();

	const [isLoading, setIsLoading] = useState(false);

	const loader = () => {
		const controller = new AbortController();
		const loadConsultation = async () => {
			if (!id || isNaN(id)) return;

			setIsLoading(true);
			try {
				const res = await xhr.get<Consultation>(`${consultationApi}${id}/`, {
					signal: controller.signal,
				});

				if (!res.data) throw res;

				setConsultation(res.data);
			} catch (error) {
				if (isAxiosError(error)) {
					if (error.response?.status === 404) {
						popup({ type: 'error', text: 'Консультация не найдена' });
						if (onError) onError();
					}
				}
			}
			setIsLoading(false);
		};

		loadConsultation();

		return () => {
			controller.abort();
		};
	};

	useEffect(loader, [id]);
	return {
		isLoading,
	};
};
